import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getGlobalScheduleRules } from "~/api/global-schedule-rules";

const GLOBAL_SCHEDULE_RULES_KEY = ["global-schedule-rules"] as const;

export const useGlobalScheduleRules = (enabled = true) =>
  useQuery({
    queryKey: GLOBAL_SCHEDULE_RULES_KEY,
    queryFn: getGlobalScheduleRules,
    enabled,
  });

export const useInvalidateGlobalScheduleRules = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({ queryKey: GLOBAL_SCHEDULE_RULES_KEY });
};
